
// The feedback types submitted by the user
export const FEEDBACK_TYPES = [
    {value: 'bug_report', label: 'Bug Report', color: 'secondary'},
    {value: 'comment', label: 'Comment', color: 'primary'},
    {value: 'feature_request', label: 'Feature Request', color: 'primary'},
];
